import BackendService from './BackendService';

async function CustomerOutstandingReport(data) {
  return BackendService.postData(`/reports/customers-outstanding/`, data);
}

const CustomerReportService = {
  CustomerOutstandingReport,
};

export default CustomerReportService;